import { Bus } from "run-scene-v2";
let bus = new Bus();
export default bus;